import { createEvent, createStore, sample } from 'effector';
import { MenuType, PORTAL_MENU_TYPE, PortalBlock, PortalEditWidgetType } from '@nx-frontend/shared/types';

export const selectedWidgetEvent = createEvent<{
  selectedWidget: PortalEditWidgetType | PortalBlock;
  fromUser?: boolean;
}>();

export const selectSidebarWidgetEvent = createEvent<PORTAL_MENU_TYPE>();

export interface EditWidgetState {
  selectedWidget: PortalEditWidgetType | PortalBlock;
  fromUser?: boolean;
}

export const initialEditWidgetState: EditWidgetState = {
  selectedWidget: PortalEditWidgetType.MAIN,
  fromUser: false,
};

export const $editWidgetState = createStore(initialEditWidgetState).on(
  selectedWidgetEvent,
  (state, { selectedWidget, fromUser }) => {
    return {
      ...state,
      selectedWidget,
      fromUser,
    };
  }
);

sample({
  clock: selectSidebarWidgetEvent,
  source: $editWidgetState,
  fn: (editWidgetState, menuType) => {
    if (editWidgetState.fromUser) {
      return {
        selectedWidget: editWidgetState.selectedWidget,
      };
    }
    if (menuType === MenuType.PORTAL_FOOTER) {
      return {
        selectedWidget: PortalEditWidgetType.FOOTER,
      };
    } else if (menuType === MenuType.PORTAL_TOPBAR) {
      return {
        selectedWidget: PortalEditWidgetType.TOPBAR,
      };
    } else {
      return {
        selectedWidget: PortalEditWidgetType.SIDEBAR,
      };
    }
  },
  target: selectedWidgetEvent,
});

export const $customizerControlbarSelectedWidget = $editWidgetState.map((state) => state.selectedWidget);
